// images
import logo from './img/logo.png';
import oksana from './img/oksana.jpg';
import pilot from './img/pilot.png';
import urbantibet from './img/urbantibet.png';
import momAndKid from './icons/mother-and-son.png';
import coach from './icons/coach.png';
import femme from './icons/femme.png';
import meeting from './icons/meeting.png';
import presentation from './icons/presentation.png';
import network from './icons/network.png';
import diplome from './icons/diplome.png';
import gmail from './icons/gmail.png';
import call from './icons/call.png';
import waytohealing from './asset/waytohealing.pdf';
// nav
import { Disclosure } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
const navigation = [
  { name: 'Home', href: '#home', current: true },
  { name: 'About', href: '#about', current: false },
  { name: 'Project', href: '#project', current: false },
  { name: 'Vision', href: '#vision', current: false },
  { name: 'Contact', href: '#contact', current: false },
]
function App() {
  return (
    <div className="container mx-auto font-poppin">
      <Disclosure as="nav" className="bg-gray-300">
      {({ open }) => (
        <>
          <div className="w-full  ">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-800 hover:bg-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-between sm:items-stretch ">
                <div className="flex flex-shrink-0 items-center m-2">
                  <div className="flex items-center h-8 w-auto lg:hidden">
                    <img src= {logo} alt="way to healing logo" className=" h-8 w-auto" />
                    <h1 className="px-2 text-xl ">WAY TO HEALING</h1>
                  </div>
                  <div className="hidden h-8 w-auto lg:flex items-center">
                    <img src= {logo} alt="Your Company" className=" h-8 w-auto" />
                    <h1 className="text-xl px-2">WAY TO HEALING</h1>
                  </div>
                </div>
                <div className="hidden sm:ml-6 sm:block m-2">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current ? 'bg-blue-600 text-white' : 'text-gray-800 hover:bg-gray-500 hover:text-white',
                          'px-3 py-2 rounded-md text-sm font-medium'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              
            </div>
          </div>
            <Disclosure.Panel className="sm:hidden ">
            <div className="space-y-1 px-2 pt-2 pb-3 ">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-900 text-white' : 'text-gray-800 hover:bg-blue-600 hover:text-white',
                    'block px-3 py-2 rounded-md text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel> 
        </>
      )}
    </Disclosure>
      
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center"
            style={{
              minHeight: "75vh"
            }}>
          <div className="absolute top-0 w-full h-full bg-center bg-cover"
              style={{
                backgroundImage: "url('https://images.unsplash.com/photo-1590363763899-f0b78a7bb968?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')"
              }}>
            <span id="blackOverlay" className="w-full h-full absolute opacity-20 bg-black"></span>
          </div>
          <div className="container relative mx-auto" id="home">
              <div className="items-center flex flex-wrap ">
                <div className="w-full lg:w-6/12 px-12 font-montserrat ">
                  <div className="pr-12">
                  <h2 className="text-3xl text-gray-300 md:text-4xl">EMOTIONAL AND PSYCHOLOGICAL </h2>
                  <h1 className='text-6xl md:text-8xl text-blue-600'>SUPPORT</h1> 
                  <h2 className="text-3xl md:text-4xl text-gray-300">TO UKRAINIAN REFUGEES </h2>
                  </div>
                </div>

              </div>
          </div>
        </div>
        {/* ------- Three cards ----------- */}
        <section className="pb-20 bg-gray-300 -mt-24">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap">
              <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white text-center inline-flex items-center justify-center w-12 h-12 mb-5 ">
                      <img src={momAndKid} alt='icon of a mother and child walking'/>
                    </div>
                    <h6 className="text-2xl font-semibold font-montserrat">In solidatiry</h6>
                    <p className="mt-2 mb-4 text-gray-600">
                    The program is developed and delivered by a coach who is Ukrainian refugee who herself has fled war, and who understands the context and the culture of Ukrainians

                    </p>
                  </div>
                </div>
              </div>

              <div className="lg:pt-20 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white text-center inline-flex items-center justify-center w-12 h-12 mb-5 ">
                    <img src={coach} alt='icon of a coaching and being successful'/>
                    </div>
                    <h6 className="text-2xl font-semibold font-montserrat">
                      Coach
                    </h6>
                    <p className="mt-2 mb-4 text-gray-600">
                    The program is developed and delivered by a coach who is Ukrainian refugee who herself has fled war, and who understands the context and the culture of Ukrainians
                    </p>
                  </div>
                </div>
              </div>

              <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-white text-center inline-flex items-center justify-center w-12 h-12 mb-5">
                    <img src={meeting} alt='icon of a meeting'/>
                    </div>
                    <h6 className="text-2xl font-semibold font-montserrat">
                      Support
                    </h6>
                    <p className="mt-2 mb-4 text-gray-600">
                    Through work in groups, the coach can help these women deal with topics such as fear, anger, pain, loss, but also possibilities, future, dreams, hope
                    </p>
                  </div>
                </div>
              </div>
            </div>

              {/* ----------- About us -------------*/}
            <div className="flex flex-wrap items-center mt-32" id='about'>
              <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                <div className=" text-gray-600 flex items-center justify-center w-20 h-20 mb-6 shadow-lg rounded-full bg-yellow-300">
                  <h3 className="text-3xl font-semibold font-montserrat pl-28">
                  Oksana POGORELOVA
                </h3>
                </div>
                
                <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-700">
                Professional coach and teacher with more than 20 years of experience, Oksana has specific experience with children at risk and vulnerable groups and has developed a specific coaching system applied in her school in Ukraine with an impressive track-record. She works in Ukrainian, Russian and English.
                After the first Russian invasion in 2014, Oskana participated in official project to support women and children at risk and the skills and experience that she gained then, is the solid foundation for this project.
                Oksana is bachelor in Economics, specialized Lawyer-Manager.
                </p>
                <p className="text-md leading-relaxed mt-0 mb-4 text-gray-700">
                Oksana fled Ukraine helping a colleague and friend – Nataliia Volkova; in March 2022, they made a long journey in the trunk of a car, a bus… and arrived in Paris with the help of the HERA-France. She wants to help fellow Ukrainians and do something useful before she can go back and join the rebuilding efforts in her home country. In an effort to support herself and her daughter, Oksana got accepted to an entrepreneur program for refugees in Paris and has also managed to get a part-time job as a English-speaking guide.

                </p>
              </div>

              <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blue-600">
                  <img
                    alt="picture of the founder of way to healing"
                    src={oksana}
                    className="w-full align-middle rounded-t-lg"
                  />
                  <blockquote className="relative p-8 mb-4">
                    <svg
                      preserveAspectRatio="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 583 95"
                      className="absolute left-0 w-full block"
                      style={{
                        height: "95px",
                        top: "-94px"
                      }}
                    >
                      <polygon
                        points="-30,95 583,95 583,65"
                        className="text-blue-600 fill-current"
                      ></polygon>
                    </svg>
                    <h4 className="text-xl font-bold text-white ">
                    Oksana POGORELOVA
                    </h4>
                    <p className="text-md font-light mt-2 text-white">
                      A professional coach and teacher with more than 20 years of experience, especially with children, risk families and vulnerable groups.
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative py-16">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
            style={{ height: "80px" }}>
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100" x="0" y="0" >
              <polygon className="text-white fill-current" points="2560 0 2560 100 0 100"></polygon>
            </svg>
          </div>
        </section>
        {/* --------- PROJECT ---------*/}
        <section className="pt-12 md:pt-20 pb-36" id='project'>
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center text-center mb-16">
              <div className="w-full lg:w-6/12 px-4">
                <h1 className="text-6xl font-semibold font-montserrat pb-4">
                  <span className='text-blue-600 '>Way</span> to <span className='text-yellow-400'>Healing</span>
                </h1>
                <h3 className="text-2xl font-semibold font-montserrat leading-relaxed m-2 text-gray-600">
                  EMOTIONAL SUPPORT PROGRAM 
                  <hr />
                </h3>
              </div>
            </div>

            <div className="flex justify-evenly flex-wrap">
              {/* first subdiv */}
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4 rounded-xl shadow-lg">
                <div className="px-2 flex justify-evenly flex-wrap">                
                  <div className="pt-6 text-center">
                    <h5 className="text-2xl font-semibold text-blue-600 font-montserrat">
                      INDIRECT INTERVENTION
                    </h5>
                    <ul className="list-none mt-6">
                      <li className="py-2">
                        <div className="flex items-center">
                          <div className='mr-4'>
                            <img src={presentation} alt="" />
                          </div>
                          <div>
                            <p className="text-gray-600 text-left">
                              Developement of the program contents(support and training)
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="flex items-center">
                          <div className='mr-5'>
                            <img src={diplome} alt=""  />
                          </div>
                          <div>
                            <p className="text-gray-600 text-left">Training and qualification of refugees</p>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="flex items-center">
                          <div className='pr-2'>
                          <img src={network} alt="Icon of networking" />
                          </div>
                          <div>
                            <p className="text-gray-600 text-left">Networking with refugee hubs and partners</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div> 
              </div>
              
              {/* second sub div */}
              <div className="w-full md:w-6/12 lg:w-3/12 lg:mb-0  mb-4 md:mb-12 px-4 rounded-xl shadow-lg">
                <div className="px-2"> 
                    
                  <div className="pt-6 text-center">
                    <h5 className="text-2xl font-semibold text-yellow-400 font-montserrat">
                      DIRECT INTERVENTION
                    </h5>
                    <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <div className='mr-4'>
                          <img src={femme} alt="Icon of a female"  />
                        </div>
                        <div>
                          <h4 className="text-gray-600">Women outside of Ukraine</h4>
                        </div>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <div className='mr-4'>
                          <img src={femme} alt="Icon of a female"  />
                        </div>
                        <div>
                          <h4 className="text-gray-600">Women in Ukraine</h4>
                        </div>
                      </div>
                    </li>
                  </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className='text-center m-6'>
            <a href={waytohealing} target='_blank' className='border rounded-lg bg-yellow-400 text-blue-600 px-4 py-2' >Project detail</a>
            </div>
          </div>
         
          {/*-------- Vision -------------*/}
          <div className="container mx-auto pt-24 p-4" id='vision'>
            <div className="p-4 ">
              <div className="flex mx-auto items-center justify-center w-16 h-16 shadow-lg rounded-full bg-yellow-300">
                <h3 className=" text-6xl font-semibold font-montserrat ">
                      Vision 
                </h3>
              </div>
              <div className="items-center flex flex-wrap">
                <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                  <img
                    alt="project image"
                    className="max-w-full rounded-lg shadow-lg"
                    src={pilot}
                  />
                </div>
                <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                    <p className="mt-4 p-4 text-lg leading-relaxed text-gray-600">
                    The project can take place in refugee centers and in communities which are hosts to Ukrainians who are forcibly displaced because of the war.
                    It can be implemented as an independent initiative or in partnership with associations and non-profit organizations.
                    The program contents can also be adapted for the needs of returning refugees and for the period of rebuilding Ukraine.
                    </p>
                  </div>
                </div>
              </div>
          </div>
        </section>
        

        <section className="relative block bg-gray-900">
          <div
            className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
            style={{ height: "80px" }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-gray-900 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
          {/* ---------- Contact ------------*/}
          <div className="container mx-auto px-4 md:pb-26 lg:pt-24 lg:pb-64 ">
            <div className="flex flex-wrap text-center justify-center">
              <div className="w-full lg:w-6/12 px-4">
                <h2 className="text-6xl font-semibold text-white">
                  Join Us
                </h2>
                <p className="text-2xl leading-relaxed mt-4 mb-4 text-gray-500 font-montserrat">
                  You can support the project
                </p>
              </div>
            </div>
            <div className="flex flex-wrap mt-12 justify-center">
              <div className="w-full lg:w-3/12 px-4 text-center">
                <div className="text-gray-900 w-12 h-12 shadow-lg rounded-full bg-blue-600 inline-flex">
                </div>
                <h6 className="text-3xl mt-5 font-semibold text-white font-montserrat">
                  FINANCIALLY
                </h6>
                <p className="mt-2 mb-4 text-gray-500">
                  The money will be used to cover :
                </p>
                  <ul className="list-none my-2">
                    <li className="py-2">
                      <div className="flex items-center">
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full  bg-blue-600 mr-3">
                          </span>
                          <h4 className="text-gray-500 ">
                            Transportation costs
                          </h4>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full bg-blue-600 mr-3">
                        </span>
                        <h4 className="text-gray-500">Daily allowance for the coach</h4>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full bg-blue-600 mr-3">
                        </span>
                        <h4 className="text-gray-500">Hire new people</h4>
                      </div>
                    </li>
                  </ul>
              </div>
              <div className="w-full lg:w-3/12 px-4 mb-20">
                <div className="text-gray-900 w-12 h-12 shadow-lg rounded-full bg-yellow-400 inline-flex">
                  <i className="fas fa-poll text-xl"></i>
                </div>
                <h5 className="text-3xl mt-5 font-semibold text-white font-montserrat">
                  MATERIALS
                </h5>
                <p className="mt-2 mb-4 text-gray-500">
                  To be used for the work with groups :
                  <ul className="list-none mt-6">
                    <li className="py-2">
                      <div className="flex items-center">
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full  bg-blue-600 mr-3">
                        </span>
                        <h4 className="text-gray-500">
                          Paper and coloring pencils
                        </h4>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                        
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full bg-blue-600 mr-3">
                          </span>
                          <h4 className="text-gray-500">Simple tote bags and textile pencils</h4>
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="flex items-center">
                       
                          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full bg-blue-600 mr-3">
                          </span>
                          <h4 className="text-gray-500">Snacks and drinks for the participants</h4>
                      </div>
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="relative block py-24 lg:pt-0 bg-gray-900" id='contact'>
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center lg:-mt-64 -mt-48">
              <div className="w-full lg:w-6/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300">
                  <div className="flex-auto p-2 md:p-5 lg:p-10">
                    <h4 className="text-4xl font-semibold font-montserrat">
                     Any Support will be appreciated
                    </h4>
                    <p className="p-4 text-lg leading-relaxed mt-1 mb-4 text-gray-600">
                      If interested in supporting this project or participations in the program
                      please contact Oksana Pohorelova.
                    </p>
                      <div className='flex-row justify-evenly items-center lg:flex'>
                        <div className='flex lg:flex-row'>
                          <img src={gmail} alt="gmail icon" className='w-6 h-6' />
                          <p className='ml-2 md:ml-4 text-sm md:text-md'> pogorelovaoksana281@gmail.com</p>
                        </div>
                        <div className='flex text-sm md:text-md pt-2'>
                          <img src={call} alt="A phone icon" className='w-6 h-6' />
                          <p className='ml-2'>+33 7 88 82 93 82</p>
                        </div>

                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer className="p-4 bg-gray-300">
            <div className="justify-center sm:flex sm:items-center sm:justify-between">
              <div className='flex items-center'>

            <p>Web design by </p>
              <a href="https://www.urbantibet.com/" target="_blank"><img src={urbantibet} className="h-12" alt='urban tibet logo'/>
                </a>
                {/* <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2022 <a href="https://flowbite.com/" className="hover:underline">pilot project</a>. All Rights Reserved.
                </span> */}
              </div>

             
                {/* Social media icons */}
                {/* <div className="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
                    <a href="#" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd" /></svg>
                        <span className="sr-only">Facebook page</span>
                    </a>
                    <a href="#" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd" /></svg>
                        <span className="sr-only">Instagram page</span>
                    </a>
                    <a href="#" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" /></svg>
                        <span className="sr-only">Twitter page</span>
                    </a>
                    <a href="#" className="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clip-rule="evenodd" /></svg>
                        <span className="sr-only">GitHub account</span>
                    </a>
                </div> */}
                <ul className='flex p-2'>
                  <li className='p-2 hover:text-blue-600'><a href="#home">HOME</a></li>
                  <li className='p-2 hover:text-blue-600'><a href="#about">ABOUT</a></li>
                  <li className='p-2 hover:text-blue-600'><a href="#project">PROJECT</a></li>
                  <li className='p-2 hover:text-blue-600'><a href="#vision">VISION</a></li>
                  <li className='p-2 hover:text-blue-600'><a href="#contact">CONTACT</a></li>
                </ul>
            </div>
        </footer>
    </div>
  );
}

export default App;
